import { createSlice } from '@reduxjs/toolkit';
import { type RootState } from 'store';

export interface NotificationState {
  type: 'success' | 'error' | 'warning' | 'info' | 'longSuccess' | 'longError';
  message: string;
  show: boolean;
  isLoading: boolean;
}

const initialState: NotificationState = {
  show: false,
  message: '',
  type: 'success',
  isLoading: false,
};

export const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    showNotification(state, { payload }) {
      return {
        ...state,
        ...payload,
        show: true,
      };
    },
    clearNotification(state) {
      return {
        ...state,
        show: false,
      };
    },
    setIsLoading(state, { payload }) {
      state.isLoading = payload;
    },
  },
});

export const { showNotification, clearNotification, setIsLoading } =
  notificationSlice.actions;

export const selectNotificationsData = (state: RootState) =>
  state.ruleNotificationsReducer.notifications;

export default notificationSlice.reducer;
